import { get } from './index';
import { ICourseListResponse, IDegreeListResponse } from '../interfaces/common';

class LeadFormOptionsApi {
  static async getCourseList(params?: { [key: string]: string }) {
    const queryParams = params ? `?${new URLSearchParams(params).toString()}` : '';
    return get<ICourseListResponse | IDegreeListResponse>(`/course/list-categories${queryParams}`);
  }
}

export default LeadFormOptionsApi;
